import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import baseURL from '../Common/Config';
import Axiosfetch from '../Common/Axiosfetch';
import FailureAlert from '../Common/Failure';
import { ValidateTrackLimit, CallBackAlert } from '../Common/Validations/validation';
import IsUndefinedNullOrEmpty from '../Common/Validations/valueCheck';
import Select from 'react-select';

const TrackLimit = {
    OrgID: "",
    InitialLimit: 0,
    AddedLimit: 0,
    Remarks: null,
    IsDeleted: 0
};

const AddTrackLimits = ({ themeColor, hideTrackLimit, getTrackLimit, edit, TrackLimitdetail, Organization }) => {

    const [TrackLimitData, setTrackLimitData] = useState(TrackLimit);
    const [Org, setOrg] = useState({ value: null, label: null });

    useEffect(() => {
        if (parseInt(edit) === 1) {
            setTrackLimitData(TrackLimitdetail);

            var filterOrg = Organization.filter(o => o.value === TrackLimitdetail.OrgID);
            if (filterOrg.length > 0) {
                setOrg(filterOrg);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onTextChange = (e) => {
        let value = e.target.value;
        setTrackLimitData({ ...TrackLimitData, [e.target.name]: value });
    };

    const onNumberChange = (e) => {
        let value = e.target.value ? parseFloat(e.target.value) : 0;
        setTrackLimitData({ ...TrackLimitData, [e.target.name]: value });
    }

    const SaveTrackLimitDetails = (TrackLimit) => {
        if (ValidateTrackLimit(TrackLimit, edit)) {
            var TrackLimitdata = {
                OrgID: TrackLimit.OrgID,
                InitialLimit: TrackLimit.InitialLimit,
                AddedLimit: TrackLimit.AddedLimit,
                Remarks: IsUndefinedNullOrEmpty(TrackLimit.Remarks) ? null : TrackLimit.Remarks,
                _id: TrackLimit._id
            }

            Axiosfetch(baseURL + ((parseInt(edit) === 0) ? "CreateTrackLimit" : "EditTrackLimit"), "POST", TrackLimitdata, TrackLimitDetailsSuccess, Failure);
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    const TrackLimitDetailsSuccess = (data) => {
        if (data.success) {
            hideTrackLimit();
            getTrackLimit();
        }

        CallBackAlert(data);
    };

    const onPartnerChange = (selectedValue) => {
        if (selectedValue && selectedValue.value !== null) {
            setTrackLimitData({ ...TrackLimitData, "OrgID": selectedValue.value });
            setOrg(selectedValue);
        }
        else {
            setTrackLimitData({ ...TrackLimitData, "OrgID": "" });
            setOrg({ value: null, label: null });
        }
    }

    return (
        <div>
            <div id="addProduct" className="modal" style={{ display: "block" }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${themeColor}`}>
                        <h4 style={{ marginLeft: "5px" }}>{parseInt(edit) === 0 ? "Add" : "Edit"} TrackLimit</h4>
                        <span className="close" onClick={hideTrackLimit}>&times;</span>
                    </div>

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>
                                    <h4>Partner<span className="mandatoryStar">*</span></h4>
                                </td>
                                <td>
                                    <Select styles={{ borderRadius: "20px" }} isClearable={true}
                                        value={Org && Org.value !== null ? Org : ""}
                                        isSearchable={true} placeholder="Select Partner"
                                        options={Organization} onChange={onPartnerChange}></Select>
                                </td>
                            </tr>
                            {parseInt(edit) === 0 && (<tr>
                                <td>
                                    <h4>Limit<span className="mandatoryStar">*</span></h4>
                                </td>
                                <td>
                                    <input type="text" name="InitialLimit"
                                        className="form-control"
                                        onChange={e => onNumberChange(e)}
                                        value={!isNaN(TrackLimitData.InitialLimit) && TrackLimitData.InitialLimit > 0 ?
                                            TrackLimitData.InitialLimit : ""}></input>
                                </td>
                            </tr>)}
                            {parseInt(edit) === 1 && (<tr>
                                <td>
                                    <h4>Add Limit<span className="mandatoryStar">*</span></h4>
                                </td>
                                <td>
                                    <input type="text" name="AddedLimit"
                                        className="form-control"
                                        onChange={e => onNumberChange(e)}></input>
                                </td>
                            </tr>)}
                            <tr>
                                <td>
                                    <h4>Remarks</h4>
                                </td>
                                <td>
                                    <input type="text" name="Remarks"
                                        className="form-control"
                                        onChange={e => onTextChange(e)}
                                        value={TrackLimitData.Remarks ? TrackLimitData.Remarks : ""}></input>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2" style={{ textAlign: "right" }}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${themeColor}Focus`} onClick={() => SaveTrackLimitDetails(TrackLimitData)}>Save</button>
                                            <button type="button" className="btn btn-default" onClick={hideTrackLimit}>Close</button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default AddTrackLimits;